// Libs
import React, { createContext } from "react";
import { connect } from "react-redux";

// Component
import Variant from "./experiment/Variant";

export const ExperimentContext = createContext({ currentTest: {} });

const Experiment = ({ name, abTests, children }) => {
  const findAbTestName = () => {
    if (abTests.length > 0) {
      return abTests.find(abTest => abTest.name === name);
    }
  };
  return (
    <ExperimentContext.Provider
      value={{ currentTest: findAbTestName() || { test: false } }}
    >
      {children}
    </ExperimentContext.Provider>
  );
};

Experiment.Variant = Variant;

function mapStateToProps(state) {
  return {
    abTests: state.settings.dropshipperData.ab_tests
  };
}

export default connect(mapStateToProps)(Experiment);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/component/Experiment.js